<template>
	<base-user-list
		v-loading="loading"
		:users="users"
		detail-link="administrator-edit"
		new-link="administrator-new"
		show-filter
		@get-page="loadData" />
</template>

<script>
import { BaseUserList } from '@/components/Base';

export default {
	name: 'AdministratorList',
	components: {
		BaseUserList,
	},
	data() {
		return {
			users: {},
			loading: false,
		};
	},
	methods: {
		async loadData(params) {
			this.loading = true;
			this.users = await this.$service.admin.getList(params);
			this.loading = false;
		},
	},
};
</script>
